export const ZODIAC_PIN_VH = 3;
export const TAROT_PIN_VH = 3;

